<template>
  <div class="c-product-grade">
    <c-stars :count="product.grade" :is-small="needSmall" :is-disabled="disableStars" />
    <p :class="{'small': needSmall, 'big': !needSmall}"><span>{{ product.grade }}</span>/<span>{{ product.comCount }}</span></p>
  </div>
</template>

<script>

export default {
  name: 'CProductGrade',
  props: {
    disableStars: {
      type: Boolean,
      default: true,
    },
    productId: {
      type: Number,
      required: true,
    },
    needSmall: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      product: {},
    }
  },
  watch: {},
  created() {
    this.loadProduct()
  },
  methods: {
    loadProduct() {
      $api.products.get(this.productId).with('comCount').with('grade').then((response) => {
        this.product = response.data.content
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-product-grade {
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    &.small {
      margin-left: 10px;
      font-size: 0.8em;
    }
    &.big {
      margin-left: 10px;
      font-size: 1em;
    }
    span:last-child {
      color: #6D6F7B;
    }
  }

}
</style>
